import type { Nullable } from '@iheartjane/types';

import { cartSize } from '@jane/shared-ecomm/util';
import type { Cart, EmptyCart } from '@jane/shared/types';

export const getProductWeightUnitInCart = (
  cart?: Nullable<Cart | EmptyCart>
) => {
  if (!cart || cartSize(cart) === 0) {
    return null;
  }

  for (const p of cart.products) {
    if (p.kind === 'flower') {
      return 'g';
    }
  }

  return null;
};
